export interface Bonus {
  num: number
  title: string
  intro: string[]
  chips?: string[]
  outro?: string[]
}

export const bonuses: Bonus[] = [
  {
    num: 1,
    title: '1-TO-1 & SMALL GROUP TEACHING KIT™',
    intro: [
      'Materiale specificamente progettato per lezioni individuali, tutoring, coppie e piccoli gruppi.',
      'Include strutture di lezione, speaking tasks, attività personalizzabili, strumenti per analizzare gli obiettivi dello studente, conversation-led lessons, progress tracker e risorse per adattare attività normalmente pensate per gruppi più grandi.',
    ],
    outro: [
      'Perché insegnare a una sola persona o a un piccolo gruppo richiede una dinamica diversa.',
    ],
  },
  {
    num: 2,
    title: 'ONLINE ENGLISH CLASSROOM KIT™',
    intro: [
      'Un toolkit dedicato alle lezioni di inglese online.',
      'Attività screen-friendly, esercizi utilizzabili tramite chat, speaking activities, warm-up digitali, collaborative writing, vocabulary review, grammar practice e strutture complete per lezioni online.',
    ],
    outro: [
      'Include anche alternative da utilizzare quando non puoi condividere lo schermo o quando hai bisogno di cambiare rapidamente attività.',
    ],
  },
  {
    num: 3,
    title: 'HOMEWORK & INDEPENDENT PRACTICE PACK™',
    intro: ['Compiti e attività di consolidamento pronti da assegnare.'],
    chips: [
      'Grammar.',
      'Vocabulary.',
      'Reading.',
      'Writing.',
      'Functional English.',
      'Mixed skills.',
    ],
    outro: [
      'Materiale organizzato per livello, obiettivo e durata che permette di continuare il lavoro anche dopo la lezione senza dover creare ogni volta nuovi esercizi.',
      'Con soluzioni e modelli quando necessari.',
    ],
  },
  {
    num: 4,
    title: 'REAL-LIFE ENGLISH ROLE-PLAY PACK™',
    intro: [
      'Una raccolta di situazioni comunicative per trasformare l’inglese studiato in inglese realmente utilizzato.',
    ],
    chips: [
      'Ristoranti.',
      'Hotel.',
      'Aeroporti.',
      'Shopping.',
      'Viaggi.',
      'Telefonate.',
      'Richieste.',
      'Problemi.',
      'Customer service.',
      'Colloqui.',
      'Riunioni.',
      'Presentazioni.',
      'Conversazioni professionali.',
    ],
    outro: [
      'Ogni scenario include ruoli, obiettivi, informazioni, useful language, task e possibili variazioni per differenti livelli.',
    ],
  },
  {
    num: 5,
    title: 'TEACHER PRINTABLES & CLASSROOM ORGANIZATION KIT™',
    intro: ['Strumenti pratici per organizzare meglio il lavoro quotidiano.'],
    chips: [
      'Lesson planners.',
      'Weekly planners.',
      'Learner profiles.',
      'Lesson logs.',
      'Vocabulary trackers.',
      'Grammar trackers.',
      'Skills trackers.',
      'Progress records.',
      'Feedback forms.',
      'Student reflection sheets.',
      'Goal-setting tools.',
      'Error logs.',
      'Classroom language reference sheets.',
    ],
    outro: [
      'Materiale riutilizzabile per mantenere lezioni, studenti e progressi più organizzati.',
    ],
  },
]

export interface Outcome {
  emoji: string
  title: string
  lines: string[]
  chips?: string[]
  closing?: string[]
}

export const outcomes: Outcome[] = [
  {
    emoji: '⚡',
    title: 'RISPARMIA ORE DI PREPARAZIONE OGNI SETTIMANA',
    lines: ['Smetti di iniziare ogni lezione da una pagina bianca.'],
    chips: [
      'Apri il sistema.',
      'Scegli il livello.',
      'Individua l’obiettivo.',
      'Seleziona la lezione o l’attività.',
      'Adatta ciò che serve.',
      'E insegna.',
    ],
    closing: [
      'La tua esperienza rimane fondamentale.',
      'Semplicemente, non devi più costruire tutto da zero.',
    ],
  },
  {
    emoji: '📚',
    title: 'AVRAI FINALMENTE UN UNICO SISTEMA ORGANIZZATO',
    lines: [],
    chips: [
      'Lezioni.',
      'Grammar.',
      'Vocabulary.',
      'Speaking.',
      'Reading.',
      'Writing.',
      'Activities.',
      'Games.',
      'Assessment.',
      'Homework.',
      'Planning.',
    ],
    closing: [
      'Tutto progettato per lavorare insieme.',
      'Non dovrai più dipendere da decine di cartelle e risorse scollegate per preparare ogni nuova lezione.',
    ],
  },
  {
    emoji: '🗣️',
    title: 'RENDI PIÙ FACILE TROVARE L’ATTIVITÀ GIUSTA',
    lines: [
      'Hai bisogno di speaking? Apri la libreria dedicata.',
      'Devi lavorare sulla grammatica? Vai direttamente al toolkit.',
      'Ti servono attività rapide? Hai una sezione dedicata.',
      'Devi preparare una lezione completa? Parti dalla Ready-to-Teach Lesson Library.',
    ],
    closing: ['Meno ricerca. Più insegnamento.'],
  },
  {
    emoji: '🎯',
    title: 'ADATTA IL SISTEMA ALLE TUE LEZIONI',
    lines: [
      'Non tutti gli studenti sono uguali.',
      'Ed è proprio per questo che il sistema non cerca di sostituire l’insegnante.',
      'Sei tu a scegliere il livello, il materiale e l’attività più adatti.',
    ],
    closing: [
      'ENGLISH TEACHER PRO™ ti offre una base già costruita da selezionare, combinare e adattare in funzione dei tuoi studenti.',
    ],
  },
  {
    emoji: '😊',
    title: 'TORNA A CONCENTRARTI SULL’INSEGNAMENTO',
    lines: [
      'Il tuo valore come insegnante non sta nel passare ore a cercare esercizi.',
      'Sta nel modo in cui spieghi.',
    ],
    chips: ['Correggi.', 'Adatti.', 'Motivi.', 'Guidi.', 'Comunichi.'],
    closing: [
      'E fai progredire i tuoi studenti.',
      'Lascia che il sistema si occupi di fornirti una struttura da cui partire.',
      'E dedica la tua energia a ciò che conta davvero: insegnare.',
    ],
  },
]
